import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

const getListingUrl = (app_key: string, isSiteAdmin: boolean) => {
	const dialogOpen = isSiteAdmin ? 'installDialogOpen' : 'requestDialogOpen';
	return `${window.location.protocol}//${window.location.host}/wiki/plugins/servlet/ac/com.atlassian.confluence.emcee/enduser-discover#!/discover/app/${app_key}?${dialogOpen}=true&source=element-browser`;
};

export const experimentalMarketplaceApps: ExperimentalQueries['experimentalMarketplaceApps'] = (
	_,
	{ application, text, offset, limit, isSiteAdmin },
	{ network },
) => {
	const params = new URLSearchParams({
		application,
	});

	params.append('hosting', 'cloud');

	if (text) {
		params.append('text', text);
	}

	if (offset) {
		params.append('offset', String(offset));
	}

	if (limit) {
		params.append('limit', String(limit));
	}

	return network
		.cfetch(`https://marketplace.atlassian.com/rest/2/addons?${params}`, {
			method: 'GET',
			headers: {},
			credentials: 'omit',
		})
		.then(async (res) => {
			const data = await res.json();
			const addons = data?._embedded?.addons || [];
			return addons.map((item: any) => {
				const embedded = item?._embedded;
				return {
					key: item?.key,
					name: item?.name,
					logoUrl: embedded?.logo?._links?.highRes?.href || embedded?.logo?._links?.unscaled?.href,
					tagLine: item?.tagLine,
					ratings: {
						averageStars: embedded?.reviews?.averageStars,
						count: embedded?.reviews?.count,
					},
					listingUrl: getListingUrl(item?.key, isSiteAdmin),
				};
			});
		});
};
